import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import { PapiRequestDaDeviationWho, PapiDaDeviationWho, PapiUser } from '@wix/da-papi-types';
import { withOffset, selectors } from '../../Stream';
import { FetchType } from '../../Stream/base/types';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { fetchNext } from './actionCreators';
import { requestPuppy, isApiError } from '@wix/da-http-client';

interface PapiRequestDaDeviationWhoWithExpand extends PapiRequestDaDeviationWho {
  expand?: string;
}

function* handleFetchNext(action: ReturnType<typeof fetchNext>) {
  const { streamId } = action.payload;
  const { offset, limit, streamParams } = yield select(state => ({
    streamParams: selectors.getStreamParams(state, streamId),
    offset: withOffset.selectors.getNextOffset(state, streamId),
    limit: selectors.getItemsPerFetch(state, streamId),
  }));
  const params: PapiRequestDaDeviationWhoWithExpand = {
    deviationid: streamParams.deviationId,
    type: 'favourite',
    offset,
    limit,
    expand: 'user.profile',
  };
  const result: PapiDaDeviationWho = yield call(
    requestPuppy,
    {
      method: 'get',
      url: 'who',
      params,
    },
    undefined,
    'dadeviation'
  );
  if (!result || isApiError(result)) {
    yield put(withOffset.actions.fetchFailure({ streamId, fetchType: FetchType.Next }));
    return;
  }

  const { total, hasMore, nextOffset, results } = result;
  yield all([
    ...((results ?? []) as PapiUser[]).map(user =>
      put(setWatchingState(user.username, user.isWatching ?? false))
    ),
    put(
      withOffset.actions.fetchSuccessDeduped({
        streamId,
        hasMore: !!hasMore,
        nextOffset: nextOffset ?? undefined,
        items: results,
        total,
      })
    ),
  ]);
}

export default function* rootSaga() {
  yield all([takeEvery(fetchNext, handleFetchNext)]);
}
